import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'

export default function SignUpPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <SEO
        title="Sign Up"
        description="Create your JumpstoneAuth account and start adding authentication to your app in minutes."
        canonical="/signup"
        noindex
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-md section-padding">
          <div className="card p-8">
            <h1 className="text-2xl font-bold text-white mb-2 text-center">Create your account</h1>
            <p className="text-surface-400 text-center mb-6">Start building with JumpstoneAuth for free</p>
            {/* Sign up form placeholder */}
            <form className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-surface-300 mb-1">Full Name</label>
                <input 
                  type="text" 
                  className="w-full px-4 py-2.5 bg-surface-800 border border-surface-700 rounded-lg text-white placeholder-surface-500 focus:outline-none focus:border-brand-500"
                  placeholder="Jane Doe"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-surface-300 mb-1">Email</label>
                <input 
                  type="email" 
                  className="w-full px-4 py-2.5 bg-surface-800 border border-surface-700 rounded-lg text-white placeholder-surface-500 focus:outline-none focus:border-brand-500"
                  placeholder="you@example.com"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-surface-300 mb-1">Password</label>
                <input 
                  type="password" 
                  className="w-full px-4 py-2.5 bg-surface-800 border border-surface-700 rounded-lg text-white placeholder-surface-500 focus:outline-none focus:border-brand-500"
                  placeholder="••••••••"
                />
              </div>
              <button type="submit" className="w-full btn btn-primary">
                Create Account
              </button>
            </form>
            <p className="mt-4 text-center text-sm text-surface-500">
              Already have an account? <a href="/signin" className="text-brand-400 hover:text-brand-300">Sign in</a>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

